(function () {
    'use strict';

    angular.module('swif.reservations')
    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/reservations/configuration_view', {
            templateUrl: 'partials/openresa/configuration_view.html',
            controller: 'ReservationsConfigurationController',
            reloadOnSearch: false,
            resolve: {
                data: ['ReservationsConfigurationService', function (service) {
                    return service.resolveData();
                }]
            }
        });
    }])

    .filter('trustHtml', ['$sce', function($sce) {
        return function(html) {
            return $sce.trustAsHtml(html);
        }
    }])

    .factory('ReservationsConfigurationService', ['$q', 'swifFrameworkService',
        function ($q, swif) {
            var service = {};
            service.bookingCategories = {};
            service.bookingCategories.id = 'bookingCategories';
            service.bookingCategories.collection = undefined;
            service.bookingCategories.getCollection = function () {
                return swif.collection.getCollection(service.bookingCategories.id);
            };
            service.bookingCategories.createCollection = function () {
                return swif.collection.createOrUpdate(
                    service.bookingCategories.id,
                    'reservationCategory',
                    {},
                    {location: true}
                );
            };

            service.resaframe = {};
            service.resaframe.id = 'resaframeConfiguration';
            service.resaframe.getCollection = function() {
                return swif.collection.getCollection(service.resaframe.id);
            };
            service.resaframe.createCollection = function() {
                return swif.collection.createOrUpdate(
                    service.resaframe.id,
                    'resaframe',
                    {}
                );
            };
            service.resaframe.saveConfig = function(config) {
                swif.data.save('resaframe', config.id, config).then(function () {
                    swif.message.addInfo('save ok');
                }, function (error) {
                    swif.message.addError(error);
                });
            };

            service.resaframeRestrictedCities = {};
            service.resaframeRestrictedCities.id = 'resaframeRestrictedCities';
            service.resaframeRestrictedCities.getCollection = function() {
                return swif.collection.getCollection(service.resaframeRestrictedCities.id);
            };
            service.resaframeRestrictedCities.createCollection = function() {
                return swif.collection.createOrUpdate(
                    service.resaframeRestrictedCities.id,
                    'resaframeRestrictedCities',
                    {}
                );
            };

            service.resolveData = function () {
                return swif.route.check().then(function () {
                    var ret = $q.defer();
                    var deferred = [];
                    deferred.push(service.bookingCategories.createCollection());
                    deferred.push(service.resaframe.createCollection());
                    deferred.push(service.resaframeRestrictedCities.createCollection());
                    // add other collections into 'deferred' (if needed)
                    $q.all(deferred).then(function (data) {
                        var values = {
                            bookingCategories: data[0],
                            resaframe: data[1],
                            resaframeRestrictedCities: data[2]
                        };
                        ret.resolve(values);
                    });
                    return ret.promise;
                });
            };
            service.refresh = function (loader) {
                swif.message.loading(loader);
                var deferred = [];
                _.forEach([
                    service.bookingCategories.id,
                    service.resaframe.id,
                    service.resaframeRestrictedCities.id
                ], function (name) {
                    var collection = swif.collection.getCollection(name);
                    if (collection) {
                        deferred.push(collection.getItems());
                    }
                });
                $q.all(deferred).then(function () {
                    swif.message.loading(loader, 'ok');
                }, function () {
                    swif.message.loading(loader, 'ko');
                });
            };
            return service;
        }
    ])

    .controller('ReservationsConfigurationController', [
        '$scope', '$q', '$location', 'swifFrameworkService', 'ReservationsConfigurationService', 'data',
        function ($scope, $q, $location, swif, service, data) {
            swif.settings.page.title = 'Reservations module configuration';
            $scope.features = swif.settings.app.features;
            $scope.modules = swif.module.modules;
            $scope.loading = {items: {}};
            $scope.collections = {
                bookingCategories: data.bookingCategories,
                resaframe: data.resaframe,
                resaframeRestrictedCities: data.resaframeRestrictedCities
            };
            $scope.resaframe = $scope.collections.resaframe.items[0];
            $scope.refresh = function () {
                service.refresh($scope.loading);
            };

            // Resaframe configuration
            $scope.editConfirmationMessage = false;
            $scope.editRestricedCitiesMessage = false;
            $scope.restrictedCitiesLengthError = false;
            $scope.restrictedCitiesRemoveAllError = false;
            $scope.editAttendeesCountMessage = false;
            $scope.textVariables = [
                {code: '${dept_name}', name: 'Nom du service de la ressource'},
                {code: '${manager_name}', name: 'Nom du chef de service'},
                {code: '${manager_phone}', name: 'Numéro de téléphone du chef de service'},
                {code: '${manager_email}', name: 'Email du chef de service'},
                {code: '${company_name}', name: 'Nom de la société'},
                {code: '${company_phone}', name: 'Téléphone de la société'},
                {code: '${company_fax}', name: 'Fax de la société'},
                {code: '${company_email}', name: 'Email de la société'},
                {code: '${company_website}', name: 'Site de la société'}
            ]

            $scope.copyVariable = function(code) {
                var temp = document.createElement('input');
                document.body.appendChild(temp);
                temp.value = code;
                temp.select();
                document.execCommand('copy');
                temp.remove();
            }

            const tinymceOptions = {
                height: 150,
                plugins: 'textcolor code',
                language : 'fr_FR',
                menubar: false,
                toolbar: 'formatselect | fontselect | fontsizeselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | forecolor | code | removeformat'
            };

            swif.resources.add(['tinymce']).then(function () {
                $scope.tinymceOptions = tinymceOptions;
            });

            $scope.resaframeRestrictedCitiesPreValidate = function(data) {
                if (data.action.id === 'setDefault') {
                    return swif.data.callKw('resaframeRestrictedCities', 'set_default', [data.model.id]);
                }
                return $scope.collections.resaframeRestrictedCities.preValidate(data);
            }

            $scope.resaframeRestrictedCitiesCallback = function(error, data) {
                $scope.collections.resaframeRestrictedCities.defaultActionCallback(error, data);
                $scope.restrictedCitiesLengthError = false;
                if (data.action.id === 'setDefault') {
                    $scope.collections.resaframeRestrictedCities.refresh();
                } else if (data.action.id === 'delete') {
                    // If the user deletes the last town, deactivate restricted cities functionality
                    if ($scope.collections.resaframeRestrictedCities.items.length == 0) {
                        $scope.restrictedCitiesRemoveAllError = true;
                        $scope.resaframe.restrict_cities = false;
                        $scope.saveResaframeSettings();
                    }
                }
            }

            $scope.saveResaframeSettings = function () {
                $scope.editConfirmationMessage = false;
                $scope.editRestricedCitiesMessage = false;
                $scope.editAttendeesCountMessage = false;
                if ($scope.resaframe.restrict_cities && $scope.collections.resaframeRestrictedCities.items.length == 0) {
                    $scope.restrictedCitiesLengthError = true;
                } else {
                    service.resaframe.saveConfig($scope.resaframe);
                }
            }

            $scope.$watch('resaframe.restrict_cities', function(value) {
                if (value && $scope.restrictedCitiesRemoveAllError) {
                    // Clear error
                    $scope.restrictedCitiesRemoveAllError = false;
                }
            });
        }
    ])

    .controller('ReservationCategoryModalController', [
        '$scope', 'swifFrameworkService',
        function ($scope, swif) {
            $scope.filters = {
                parent_id: {}
            };
            swif.data.addFilter($scope.filters.parent_id, 'id', '!=', $scope.model.id || 0);
        }
    ])

    .controller('RestrictedCityModalController', ['$scope',
        function($scope) {
            // It's empty
        }
    ])

    .controller('ResaParamsController' ,[
        '$scope', 'swifOpenbaseCompanyService',
        function ($scope, swifOpenbaseCompanyService) {
            swifOpenbaseCompanyService.getGlobalSettingsResa().then(function(company) {
                $scope.globalSettingsResa = company;
            });

            $scope.saveGlobalSettingsResa = function () {
                swifOpenbaseCompanyService.saveCompany($scope.globalSettingsResa);
            };
        }
    ]);
})();
